import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Pipe({
  standalone: true,
  name: 'safeResource'
})
export class SafeResourcePipe implements PipeTransform {
  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);

  transform(url: SafeResourceUrl): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, url));
  }
}
